import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractFullMessages } from '@/utils/extract'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_PA_PARAM, QUOTE_PA_GENERAL, QUOTE_PA_ADJ_CANCEL, QUOTE_PA_PARAM_PLAN_LOADING, QUOTE_PA_PARAM_PLAN_SUCCESS, QUOTE_PA_PARAM_PLAN_FAIL, QUOTE_PA_APPLICANT, QUOTE_PA_RECALCULATE_LOADING, QUOTE_PA_RECALCULATE_SUCCESS, QUOTE_PA_RECALCULATE_FAIL } from '@/store/types'

export const pa = {
  async paQuoteInit({ commit, state }) {
    const expand = {
      intermediary: state.quotation.commonForm.intermediary
    }
    const apiUrl = expandURI(state.quotationSettings.menu.pa, expand)
    if (apiUrl) {
      commit(AGENCY_QUOTATION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu,
          relationships: result.relationships,
          occupations: result.occupations
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_PA_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async paQuoteGeneral({ commit, state }, data) {
    // Before committing the data, we will check what is affected by the change of paQuoteGeneral fields
    const commonForm = state.quotation.commonForm
    const paForm = state.quotation.paForm

    // Check if there is a change of common fields
    if (!commonForm.product || commonForm.product !== data.product || !paForm.paType || paForm.paType !== data.paType || paForm.noAdult !== data.noAdult || paForm.noChild !== data.noChild) {
      // Need clear out plan here
      commit(QUOTE_PA_ADJ_CANCEL)
    }
    // Check if there is a change of disc/comm fields (promotions)
    if (!commonForm.promotion || commonForm.promotion !== data.promotion) {
      commit(QUOTE_PA_RECALCULATE_LOADING)
    }
    commit(QUOTE_PA_GENERAL, data)
  },
  async paQuotePlans({ commit, state }) {
    const apiUrl = state.quotation.menu.paPlans
    if (apiUrl) {
      try {
        commit(QUOTE_PA_PARAM_PLAN_LOADING)

        const { commonForm, paForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          noAdult: paForm.noAdult,
          noChild: paForm.noChild,
          optCvrs: commonForm.optCvr,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion
        }
        const result = await http.post(apiUrl, calcForm)
        const { data } = result
        commit(QUOTE_PA_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
        commit(QUOTE_PA_PARAM_PLAN_FAIL, extractFullMessages(error))
      }
    } else {
      commit(QUOTE_PA_PARAM_PLAN_FAIL)
    }
  },
  async paOptCvrRecalculate({ commit, state }) {
    const apiUrl = state.quotation.menu.paPlans
    if (apiUrl) {
      try {
        const { commonForm, paForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          noAdult: paForm.noAdult,
          noChild: paForm.noChild,
          optCvrs: commonForm.optCvr,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion
        }
        const result = await http.post(apiUrl, calcForm)
        const { data } = result
        commit(QUOTE_PA_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
      }
    } else {
      commit(QUOTE_PA_PARAM_PLAN_FAIL)
    }
  },
  async paQuoteRecalculate({ commit, state }) {
    const apiURI = state.quotation.menu.recalculate
    if (apiURI) {
      commit(QUOTE_PA_RECALCULATE_LOADING)
      try {
        const { commonForm, paForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          scheme: commonForm.scheme,
          paType: paForm.paType,
          noAdult: paForm.noAdult,
          noChild: paForm.noChild,
          optCvrs: commonForm.optCvr,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          planNo: paForm.planNo,
          adjDiscount: commonForm.adjDiscount,
          discLdg: commonForm.discLdg
        }

        const result = await http.post(apiURI, calcForm)
        if (result.data) {
          const { data } = result
          commit(QUOTE_PA_RECALCULATE_SUCCESS, data)
        }
      } catch (err) {
        commit(QUOTE_PA_RECALCULATE_FAIL, extractFullMessages(err))
      }
    } else {
      commit(QUOTE_PA_RECALCULATE_FAIL, ['Invalid API URL'])
    }
  },
  paQuoteApplicant({ commit, state }, data) {
    if (data && data.applicant) {
      commit(QUOTE_PA_APPLICANT, data.applicant)
    }
  }
}
